export default __webpack_public_path__ + "static/media/uganda.00bce118.svg";